module.exports = __webpack_public_path__ + "static/media/ADD.428d7cb8.svg";